import React, { ReactNode } from "react";
import styles from "./Section.module.css";

interface SectionProps {
  children: ReactNode;
  isActive: boolean;
}

const Section: React.FC<SectionProps> = ({ children, isActive }) => {
  const className = `${styles.section} ${isActive ? styles.active : styles.inactive}`;

  return <div className={className}>{children}</div>;
};

export default Section;
